var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "resellerContainer",
      staticClass: "grid",
      attrs: { id: "reseller-container" },
    },
    [
      _c(
        "div",
        { staticClass: "col-12 col-lg-8 col-start-lg-5 rb-certified-reseller" },
        [
          _c("div", { staticClass: "rb-certified-reseller__title" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.translation("certified_resellers.title")) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          !_vm.isMobile
            ? _c("div", { staticClass: "search-title" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.translation("certified_resellers.input_label")) +
                    "\n    "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "rb-certified-reseller__search-container" },
            [
              _c(
                "div",
                { staticClass: "input-row" },
                [
                  _c("rb-textfield", {
                    attrs: {
                      id: "urlAddress",
                      type: "text",
                      name: "urlAddress",
                      disabled: false,
                      error: "",
                      validation: _vm.$v.urlAddress,
                      placeholder: _vm.getPlaceholder,
                      initialvalue: _vm.initialValue,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "rb-btn rb-btn--black",
                      attrs: {
                        "data-element-id": "X_X_Store_Resellers",
                        "data-description": "Search",
                      },
                      on: { click: _vm.onSearchClick },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.translation("certified_resellers.search_button")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _vm.isResultVisible
            ? _c("div", [
                _vm.isDomainCertifiedReseller
                  ? _c(
                      "div",
                      { staticClass: "rb-certified-reseller__result" },
                      [
                        _c("p", {
                          staticClass:
                            "common__icon common__icon--smiling-face",
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "rb-certified-reseller__result--ok" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.getCertifiedResellerMessage) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _c(
                      "div",
                      { staticClass: "rb-certified-reseller__result" },
                      [
                        _c("p", {
                          staticClass: "common__icon common__icon--sad-face",
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "rb-certified-reseller__result--not-ok",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.translation(
                                    "certified_resellers.domain_is_not"
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    ),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }